import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBezwaarMakenHuurverhoging = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M22.6 13.82c-.95-.56-2.01-.86-3.11-.86-2.87 0-5.39 2.06-6.32 5.01h6.8v5.01h-6.8c.93 2.95 3.45 5.01 6.32 5.01 1.74 0 3.37-.74 4.63-2.08l3.64 3.43c-2.12 2.27-5.04 3.67-8.27 3.67-5.66 0-10.37-4.3-11.46-10.02H5v-5.01h3.03c1.08-5.72 5.8-10.02 11.46-10.02 2.23 0 4.3.68 6.07 1.84l-2.96 4.04z"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M32 15h3l-6-8-6 8h3v9h6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M13.5 20.39h-1c0-4.35 3.54-7.89 7.89-7.89v1c-3.8 0-6.89 3.09-6.89 6.89"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBezwaarMakenHuurverhoging);

export default ForwardRef;
